import { GreenScreen } from '@/components/GreenScreen';
import { savingLoaderContent } from '@/content/savingLoaderContent';
import { Box, useMantineTheme } from '@mantine/core';
import { useParams } from '@tanstack/router';
import { useEffect } from 'react';
import { StepTitle } from '../components/StepTitle';
import { FireflyAnimated } from '../components/icons/FireflyAnimated';
import { staticStepRoute } from '../router/router';
import { useCaseUpdater } from './hooks/useCaseUpdater';

export const SavingLoader = () => {
  const theme = useMantineTheme();
  const { stepId } = useParams({ from: staticStepRoute.id });

  const { title } = savingLoaderContent;

  const { mutate } = useCaseUpdater({});

  useEffect(() => {
    const formData = new FormData();
    formData.append('stepId', stepId);
    formData.append('answer', 'true');
    setTimeout(() => {
      mutate(formData);
    }, 4500);
  }, [mutate, stepId]);

  if (!stepId) throw new Error('StepId should be defined on SavingLoader step');

  return (
    <GreenScreen
      stepId={stepId}
      withPrimaryButton={false}
    >
      <Box mt={100} />
      {!!title &&
        (typeof title === 'string' ? (
          <StepTitle
            isInverted
            ta="center"
            mt={40}
            w="100%"
          >
            {title}
          </StepTitle>
        ) : (
          title()
        ))}
      <FireflyAnimated
        color={theme.colors.tertiary[1]}
        floodColor={theme.colors.secondary[0]}
      />
    </GreenScreen>
  );
};
